import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";

// TODO: cambiar 'config' a 'defs' cuand sea implementado nuevamente en back
const DEFS = 'defs/config';

export default {
    methods: {
        async getDefs() {
            const url = `${baseURL}${DEFS}`
            const response = await this.httpSession().get(url)
            console.debug('[DEFS_CONFIG][getDefs] RESPONSE', response.data)
            return response.data;
        }
    },
    mixins: [SessionApi],
};
